import { createContext } from "react";
import { IAuthService } from "../authentication/AuthService";

export interface Auth {
  isAuthenticated: boolean;
  authService: IAuthService;
  account: any | null;
}

const AuthContext = createContext<Auth>({
  isAuthenticated: false,
  authService: null as any,
  account: null,
});

export default AuthContext;
